const $ = require('jquery')
const Vue = require('vue')
const SCI = require('sci')
const { client, simpleCache, notificationsClient } = require('sci/helpers')
const { string } = require('sci/std')

const widgets = SCI.get('menu.widgets')
const badges = SCI.get('menu.badges')
const trialCountDownTemplate = require('templates/trial-countdown.html')
const billingAlertsTemplate = require('templates/billing-alerts.html')
const systemAlertsTemplate = require('templates/system-alerts.html')
const moment = require('moment')
const PropertyCreationModal = require('components/property/CreationModal.vue')
const TopNavbar = require('components/ui/TopNavbar.vue')

Vue.component('menu_widget', {
    props: ['name', 'data'],
    template: '<div></div>',
    ready () {
        if (!widgets || !widgets.hasOwnProperty(this.name)) {
            return
        } else {
            this.data = widgets[this.name]
        }

        $(this.$el).append(`<${this.name} :alias="name" :data="data"></${this.name}>`)
        this.$compile(this.$el)
        $(this.$el).find('.grid-item').attr('data-alias', this.name).unwrap()
    }
})

Vue.component('menu_badge', {
    props: ['name', 'data'],
    template: '<span class="badge badge-info bg-orange" v-if="data && data.info.count > 0">{{data.info.count}}</span>',
    ready () {
        if (!badges || !badges.hasOwnProperty(this.name)) {
            return
        } else {
            this.data = badges[this.name]
        }
    }
})

let counters = Promise.resolve({})

if (SCI.get('user')) {
    counters = client
        .background()
        .get('Carregando contadores...', '/counters/fetch-all')
        .then((response) => {
            return response.data
        })
}

Vue.component('menu_counter', {
    props: ['name'],
    template: '<span v-if="count">({{count}})</span>',
    data: () => ({
        count: 0
    }),
    ready () {
        counters.then((data) => {
            if (data.hasOwnProperty(this.name)) {
                this.count = data[this.name]
            }
        })
    }
})

Vue.component('trial-countdown', {
    props: [],
    template: trialCountDownTemplate,
    data: () => ({
        showTrial: false,
        expiration: null,
        parsed: null,
        result: null,
        finishing: false
    }),

    ready () {
        this.display()
    },
    methods: {
        requireSpace () {
            this.$pushTopMargin('trial-alerts', 40)
        },
        display () {
            simpleCache('settings')
                .then((data) => {
                    if (data.data.trial.expires_at) {
                        this.showTrial = true

                        const expiration = moment.utc(data.data.trial.expires_at)

                        if (expiration.clone().subtract(5, 'minutes').isBefore(new Date())) {
                            this.finishing = true
                        }

                        this.result = expiration.fromNow()

                        this.expiration = expiration

                        this.requireSpace()
                    }
                })
        }
    }
})

const alertTypes = {
    'warning': 'bg-yellow',
    'critical': 'bg-red',
    'info': 'bg-blue'
}

const alertPriorities = {
    'warning': 2,
    'critical': 1,
    'info': 3
}

Vue.component('billing-alerts', {
    props: [],
    template: billingAlertsTemplate,
    data: () => ({
        showBillingAlerts: false,
        message: null,
        type: null
    }),

    ready () {
        this.display()
    },
    methods: {
        requireSpace () {
            this.$pushTopMargin('billing-alerts', 40)
        },
        display () {
            simpleCache('billing')
                .then((data) => {
                    if (data.data.alert && (data.data.alert_global || this.$user.is_instance_owner)) {
                        this.showBillingAlerts = true
                        this.message = data.data.alert
                        let type = data.data.alert_type || 'critical'
                        if (!alertTypes.hasOwnProperty(type)) {
                            type = 'critical'
                        }
                        this.type = type
                        this.requireSpace()
                    }
                })
        }
    },
    computed: {
        bgColor () {
            if (this.type) {
                return alertTypes[this.type]
            }

            return null
        }
    }
})

Vue.component('navbar-notifications', require('components/notifications/Navbar.vue'))

Vue.component('system-alerts', {
    props: [],
    template: systemAlertsTemplate,
    data: () => ({
        show: false,
        message: null,
        type: null
    }),
    ready () {
        this.display()
    },
    methods: {
        requireSpace () {
            this.$pushTopMargin('system-alerts', 40)
        },
        display () {
            client
                .background()
                .post('Verificando status...', '/status', {
                    path: (location.pathname && location.pathname.replace(/^\//, '')) || null
                })
                .then((data) => {
                    if (data.data) {
                        if (data.data.length > 0) {
                            this.show = true

                            const messages = data.data.map((item) => {
                                let priority = 1

                                if (item.type && alertPriorities.hasOwnProperty(item.type)) {
                                    priority = alertPriorities[item.type]
                                }

                                return { ...item, priority }
                            }).sort(function (a, b) {
                                if (a.priority > b.priority) {
                                    return 1
                                }
                                if (a.priority < b.priority) {
                                    return -1
                                }

                                return 0
                            })

                            this.type = messages[0].type

                            this.message = messages.map((item) => {
                                return item.message
                            }).join('; ')

                            this.requireSpace()
                        }
                    }
                })
        }
    },
    computed: {
        bgColor () {
            if (this.type) {
                return alertTypes[this.type]
            }

            return null
        }
    }
})

if (document.getElementById('top-navbar-root')) {
    let previousMargin = []
    new Vue({
        el: '#top-navbar-root',
        components: {
            TopNavbar,
            PropertyCreationModal
        },
        data () {
            return {
                registeredTopMargin: previousMargin,
                requiredTopMargin: 0
            }
        },
        ready () {
            SCI.bus().$on('remove-top-margin', ({ id }) => {
                this.registeredTopMargin = this.registeredTopMargin.filter((i) => {
                    return i.id !== id
                })
                previousMargin = this.registeredTopMargin

                this.calculateTopMargin()
            })

            SCI.bus().$on('push-top-margin', ({ id, size }) => {
                this.registeredTopMargin.push({ id, size })

                previousMargin = this.registeredTopMargin

                this.calculateTopMargin()
            })

            this.calculateTopMargin()
        },
        methods: {
            showSettingsModal () {
                SCI.bus().$emit('dashboard:show-settings-modal')
            },
            calculateTopMargin () {
                this.requiredTopMargin = this.registeredTopMargin.reduce((a, b) => {
                    return a + b.size
                }, 0) + 'px'

                window.$requiredTopMargin = this.registeredTopMargin.reduce((a, b) => {
                    return a + b.size
                }, 0)
            }
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/top-navbar.js